import React from 'react'
import MobileFooter from "./mobileFooter"
import DesktopFooter from "./webFooter"

const Index = ({footerData}) => {
  return (
    <>
<DesktopFooter footerData={footerData}/>
<MobileFooter footerData={footerData}/>
    </>
  )
}

export default Index